import { render } from "./CoDiver.vue?vue&type=template&id=3242d02e"
import script from "./CoDiver.vue?vue&type=script&lang=js"
export * from "./CoDiver.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__